<template>
  <div v-if="hasDealer && authLevel.toLowerCase() !== 'interested'">
    <!-- {{ allFlags }} -->
    <v-navigation-drawer
      :mini-variant.sync="miniVariant"
      :clipped="clipped"
      :value="drawer && hideDrawer"
      :disable-resize-watcher="false"
      fixed
      app
    >
      <v-toolbar flat color="secondary">
        <v-list>
          <v-list-tile @click="navigate('/')">
            <v-list-tile-title class="title">Start</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>home</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list>
        <v-list-tile
          v-for="(item, index) in sidebarItems.filter((x) =>
            $store.getters['orders/changeLessee/createOnly']
              ? x.title == 'Change Lessee'
              : true
          )"
          v-show="$route.name !== 'home'"
          :key="index"
          @click="status(item.title) ? navigate(item.route) : ''"
        > 
          <v-list-tile-action v-if="status(item.title)">
            <v-icon
              v-if="hasData(item) == true"
              :color="item.invalid && !isQuote ? 'red' : 'green'"
            >
              {{ item.invalid && !isQuote ? 'cancel' : 'check_circle' }}
            </v-icon>
            <v-icon v-else :color="item.invalid && !isQuote ? 'red' : ''">
              {{ item.invalid && !isQuote ? 'cancel' : item.icon }}
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content v-if="status(item.title)">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <list-group-admin
          v-if="isAdmin && !$store.getters['orders/changeLessee/createOnly']"
          :auth-group="authGroup"
        ></list-group-admin>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapState } from 'vuex';
const { mapActions: mapMenuActions } = createNamespacedHelpers(`orders/menu`);
const { mapState: mapOrderState, mapGetters: mapOrderGetters } =
  createNamespacedHelpers(`orders`);
import { mapMenuMultiRowFields } from '@/store/modules/orders';
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);
import AdminMenu from './admin/list-group-admin';
import items from './menuItems';

export default {
  name: 'Sidebar',
  components: { 'list-group-admin': AdminMenu },
  props: ['drawer'],
  data() {
    return {
      clipped: true,
      fixed: false,
      right: true,
      rightDrawer: false,
      title: 'Vonex',
      enabledClass: 'enabled',
      disabledClass: 'disabled',
      items: items.items,
      miniVariant: false,
    };
  },
  computed: {
    ...mapState('orders', ['summary']),
    ...mapOrderState([
      'auth',
      'message',
      'rows',
      'address',
      'company',
      'customer',
      'landline',
      'newChurn',
      'required_fields',
    ]),
    ...mapOrderGetters([
      'hasDealer',
      'hasOrder',
      'isSigned',
      'hasAddress',
      'isAdmin',
      'isChangeOfAddress',
      'isChangeOfLessee',
      'authGroup',
      'authLevel',
      'isQantas',
      'isResidential',
      'isGrenke',
      'isQuote',
      'quoteToolFlag',
    ]),
    ...mapMenuMultiRowFields({ savedData: 'rows' }),
    ...mapFeatureFlagGetters(['allFlags']),

    isLoggedIn() {
      return this.$auth.isAuthenticated;
    },
    hideDrawer: function () {
      return this.$route.name == 'OrderApprove'
        ? false
        : this.isLoggedIn == null
        ? false
        : this.isLoggedIn;
    },
    hasStartedOrder: function () {
      return this.$route.name !== 'home';
    },
    menuItems: function () {
      let vm = this;

      //TO DO: remove feature flag
      if (vm.quoteToolFlag && vm.isQuote) {
        return vm.items
          .filter(
            (x) =>
              x.title &&
              vm.status(x.title) &&
              x.title !== 'Sign and Send' &&
              x.title !== 'Guarantor' &&
              x.title !== 'Finance Application' &&
              x.route !== 'create-fax'
          )
          .filter((x) =>
            vm.allFlags.SOG4035 ? x.title !== 'Direct Debit' : true
          );
      } else
        return vm.items.filter(
          (x) =>
            x.title &&
            vm.status(x.title) &&
            x.title !== 'Quote Details' &&
            x.title !== 'Generate Quote' &&
            x.route !== 'create-fax-quote'
        );
      // .filter(x => (this.isGrenke ? true : x.title != "Direct Debit"));
    },
    sidebarItems: function () {
      let vm = this;
      if (vm.menuItems.length == 0) return [];

      return vm.menuItems.map((item) => {
        let newItem = { ...item, invalid: false };
        vm.required_fields.map((field) => {
          if (vm.rows.length && vm.summary.reportView.orderID) {
            if (field.path[0].includes(item.route)) {
              switch (item.route) {
                case 'create-company':
                  newItem.invalid =
                    !vm.company.company.abn && !vm.company.company.acn;
                  break;
                default:
                  newItem.invalid = true;
                  break;
              }
            }
          }
        });
        return newItem;
      });
    },
  },
  watch: {
    $route(to, from) {
      let vm = this;
      vm.$eventBus.$emit('showValidation', false);
      if (this.$auth.isAuthenticated) vm.getStatus();
    },
    // rows: {
    //   handler: function (prev, next) {
    //     let vm = this;
    //     vm.$eventBus.$emit('showValidation', false);
    //     if (this.$auth.isAuthenticated) vm.getStatus();
    //   },
    //   deep: true,
    // },
  },
  methods: {
    ...mapMenuActions(['getStatus']),
    hasData: function (el) {
      let descriptionList = this.savedData.map((x) => x.description);  
      return (
        descriptionList.includes(el.route) ||
        descriptionList.some((item) => el.route.includes(item))
      );
    },
    navigate: function (route) {
      let current = this.$router.currentRoute.path;
      if (`/${route}` == current) return;
      if (route === 'attachments') {
        this.$router.push({
          path: `/${route}/general`,
        });
      } else if (route === '/') {
        this.$store.commit('orders/changeLessee/setCreateOnly', false);
        this.$router.replace(`${route}`);
      } else this.$router.push(`/${route}`);
    },
    status: function (el) {
      //if (this.isAdmin) return true;
      var result = true;
      switch (el) {
        case 'Residential':
          result =
            this.isResidential && (this.isLoggedIn || false) && this.hasDealer;
          break;
        case 'Business':
          result =
            !this.isResidential && (this.isLoggedIn || false) && this.hasDealer;
          break;
        case 'Auth Rep':
          result =
            !this.isResidential && (this.isLoggedIn || false) && this.hasDealer;
          break;
        case 'Guarantor':
          result =
            !this.allFlags.SOG8484 &&
            !this.isResidential &&
            (this.isLoggedIn || false) &&
            this.hasDealer &&
            this.rows[0].customerDetails &&
            this.rows[0].customerDetails.isGuarantor == false;
          break;
        case 'Manage Qantas Admin':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'Maintain Rate Plans':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'Maintain Handsets':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'Dealer Logins':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'View In-progress Orders':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'Edit Auth':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'Manage Admin Accounts':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'Change Address':
          result =
            (this.isLoggedIn || false) &&
            this.hasOrder &&
            this.hasAddress &&
            this.isChangeOfAddress;
          break;
        case 'Change Lessee':
          result =
            (this.isLoggedIn || false) &&
            this.hasOrder &&
            this.hasAddress &&
            this.isChangeOfLessee;
          break;
        case 'IP Voice':
          result =
            (this.isLoggedIn || false) &&
            this.hasOrder &&
            this.hasAddress &&
            !(this.isChangeOfAddress || this.isChangeOfLessee) &&
            !this.isResidential;
          break;
        case 'Fixed Line':
        case 'Hardware':
        case 'Other Charges (Internal)':
          result =
            (this.isLoggedIn || false) && this.hasOrder && this.hasAddress;
          break;
        case 'Other Charges':
          result =
            (this.isLoggedIn || false) && this.hasOrder && this.hasAddress && this.allFlags.SOG4269;
          break;
        case 'Internet':
        case 'IP Porting':
          result =
            (this.isLoggedIn || false) &&
            this.hasOrder &&
            this.hasAddress &&
            !(this.isChangeOfAddress || this.isChangeOfLessee);
          break;
        case 'Attachments':
          result =
            (this.isLoggedIn || false) && this.hasOrder && this.hasAddress;
          break;
        case 'Finance Application':
          result = 
          !this.allFlags.SOG8484 && 
          (this.isLoggedIn || false) && this.hasOrder && this.hasAddress;
          break;
        case 'Teams':
          result =
            (this.isLoggedIn || false) &&
            this.hasOrder &&
            this.hasAddress &&
            !(this.isChangeOfAddress || this.isChangeOfLessee);
          break;
        case 'SIP':
        case 'Direct Debit':
        case 'Mobile':
        case 'Inbound':
        case 'Fax':
        //case "Change Lessee":
        // eslint-disable-next-line no-fallthrough
        case 'Call Management Console':
          result =
            (this.isLoggedIn || false) &&
            this.hasOrder &&
            this.hasAddress &&
            !(this.isChangeOfAddress || this.isChangeOfLessee);
          break;
        case 'Sign and Send':
          if (this.isSigned) return true;
          break;
        default:
          result = true;
          break;
      }

      return result && (this.isAdmin ? true : !this.isSigned);
    },
    collapseService: function () {
      this.IsService = !this.IsService;
    },
    collapseExisting: function () {
      this.IsExisting = !this.IsExisting;
    },
    hasDirectDebit() {
      if (this.rows[0].customerDetails) {
        if (!this.isGrenke) {
          if (this.rows[0].customerDetails.directDebit == 'Yes')
            return this.menuItems.filter((x) => x.title != 'Direct Debit');
          else {
            return this.menuItems;
          }
        }
      } else {
        return this.menuItems;
      }
      return this.menuItems;
    },
  },
};
</script>
<style scoped>
.expand {
  height: auto !important;
  display: block !important;
}

.new-collapse {
  display: none !important;
}
</style>
